import { CustomSelect } from "../../CustomSelect";
import { MinusIcon, PlusIcon } from "../../../assets/svg/ProuductIcons";
import { useFetchData, usePostApiRequest } from "../../../helpers/api";
import { useEffect, useState } from "react";
import LoadingSpinner from "../../loading/LoadingSpinner";

const shapeOptions = [
  { value: "ROUND", label: "ROUND" },
  // { value: "Princess", label: "Princess" },
  // { value: "Cushion", label: "Cushion" },
  // { value: "Oval", label: "Oval" },
  // { value: "Radiant", label: "Radiant" },
  // { value: "Emerald", label: "Emerald" },
  // { value: "Pear", label: "Pear" },
  // { value: "Heart", label: "Heart" },
];

const CustomFilter = ({
  customFilterData,
  setCustomFilterData,
  customerId,
}) => {
  const [isLoadingApi, setIsLoadingApi] = useState(false);
  const postApiRequest = usePostApiRequest();
  const { data: diamondSizeData } = useFetchData(
    ["diamondSizeFilterModal"],
    "/Customer/GetDiamondSize",
    { Shape: "ROUND" }
  );
  const { data: stockData } = useFetchData(
    "customerStock",
    "/Customer/GetCustomerStock",
    { CustomerId: Number(customerId) }
  );

  useEffect(() => {
    if (stockData?.Data?.length) {
      const formattedStockData = stockData.Data.map((item) => ({
        Id: item.Id || 0,
        Shape: item.Shape || "ROUND",
        Size: item.Size?.toString() || "",
        Weight: item.CaratWeight || "",
        Pcs: item.NumberOfPCS?.toString() || "",
        SizeCode: item.SizeCode || "",
        CustomerId: Number(customerId),
      }));

      setCustomFilterData(formattedStockData);
    }
    // eslint-disable-next-line
  }, [stockData, setCustomFilterData]);

  const addRow = () => {
    setCustomFilterData((prevData) => [
      ...prevData,
      {
        Id: 0,
        Shape: "ROUND",
        Size: "",
        Weight: "",
        Pcs: "",
        SizeCode: "",
        CustomerId: Number(customerId),
      },
    ]);
  };

  const removeRow = async (index, rowId) => {
    if (rowId > 0) {
      setIsLoadingApi(true);
      try {
        const response = await postApiRequest({
          url: "/Customer/DeleteCustomerStock",
          method: "POST",
          data: { Id: rowId, CustomerId: customerId },
          queryKey: ["customerStock"],
          noToast: true,
        });

        if (response.Status === true) {
          setCustomFilterData((prevData) =>
            prevData.filter((_, i) => i !== index)
          );
        }
      } catch (error) {
        console.error("API call failed:", error);
        return;
      } finally {
        setIsLoadingApi(false);
      }
    } else {
      setCustomFilterData((prevData) => prevData.filter((_, i) => i !== index));
    }
  };

  const handleChange = (index, field, value) => {
    setCustomFilterData((prevData) =>
      prevData.map((row, i) => {
        if (i !== index) return row;

        let updatedRow = { ...row, [field]: value };

        const selectedSizeOption = diamondSizeData?.Data?.find(
          (option) => option.Pointer === parseFloat(updatedRow.Size)
        );

        const pointerValue = selectedSizeOption?.Pointer || 0;
        const sizeCodeValue = selectedSizeOption?.SizeCode || "";

        if (field === "Size") {
          updatedRow = {
            ...updatedRow,
            SizeCode: sizeCodeValue,
          };

          if (
            updatedRow.Pcs &&
            !isNaN(parseFloat(updatedRow.Pcs)) &&
            pointerValue
          ) {
            updatedRow.Weight = (
              parseFloat(updatedRow.Pcs) * pointerValue
            ).toFixed(4);
          } else {
            updatedRow.Weight = "";
          }
        }

        if (field === "Pcs") {
          if (value === "" || isNaN(parseFloat(value))) {
            updatedRow.Weight = "";
          } else if (pointerValue) {
            updatedRow.Weight = (parseFloat(value) * pointerValue).toFixed(4);
          }
        }

        if (field === "Weight") {
          if (value === "" || isNaN(parseFloat(value))) {
            updatedRow.Pcs = "";
          } else if (pointerValue) {
            updatedRow.Pcs = Math.round(parseFloat(value) / pointerValue);
          }
        }

        return updatedRow;
      })
    );
  };

  const mapOptions = (data, valueKey, labelKey) =>
    data?.map((option) => ({
      value: String(option[valueKey]),
      label: option[labelKey],
    }));

  return (
    <div className="customFilterCon">
      {isLoadingApi && <LoadingSpinner />}
      {customFilterData.map((row, index) => (
        <div key={index} className="customFilterRow">
          {/* Shape Dropdown */}
          <div className="input_con">
            <CustomSelect
              options={shapeOptions}
              value="ROUND"
              onChange={(value) => handleChange(index, "Shape", value)}
              placeholder="Select Shape"
              showLabel={true}
              labelName="Select Shape"
            />
          </div>

          {/* Size Dropdown */}
          <div className="input_con">
            <CustomSelect
              options={mapOptions(diamondSizeData?.Data, "Pointer", "SizeCode")}
              value={row.Size}
              onChange={(value) => handleChange(index, "Size", value)}
              placeholder="Select Size"
              showLabel={true}
              labelName="Select Size"
              customClass="size_custom_filter"
            />
          </div>

          {/* Pieces Input */}
          <div className="input_con">
            <label htmlFor={`custom_filter_pcs_${index}`}>Number of PCS.</label>
            <input
              type="text"
              id={`custom_filter_pcs_${index}`}
              name="custom_filter_pcs"
              value={row.Pcs}
              onChange={(e) => handleChange(index, "Pcs", e.target.value)}
            />
          </div>

          {/* Weight Input */}
          <div className="input_con">
            <label htmlFor={`custom_filter_carat_${index}`}>Carat Weight</label>
            <input
              type="text"
              id={`custom_filter_carat_${index}`}
              name="custom_filter_carat"
              value={row.Weight}
              onChange={(e) => handleChange(index, "Weight", e.target.value)}
            />
          </div>

          <div className="row_manage_button_con">
            {/* Remove Row Button */}
            {customFilterData.length > 1 && (
              <button
                onClick={() => removeRow(index, row.Id)}
                className={`dec_qty ${
                  index === customFilterData.length - 1 ? "has_plus_btn" : ""
                }`}
              >
                <MinusIcon />
              </button>
            )}

            {/* Add Row Button */}
            {index === customFilterData.length - 1 && (
              <button
                onClick={addRow}
                className={`inc_qty ${
                  customFilterData.length === 1 ? "default_plus_btn" : ""
                }`}
              >
                <PlusIcon />
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomFilter;
